import React, { memo } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';

import BaseText from '../BaseText';

import { Color, CommonProperties } from '../../styles';
import { useSelector } from 'react-redux';
import {
  selectCompanyCurrency,
  selectCompanyCurrencyCulture,
} from '../../store/selectors/auth.selector';
import { getCurrencySymbolForSeatMapFare } from '../../utils/currency.utils';
import { AA_ENABLED } from '../../config/env';

const SeatUnit = (props) => {
  const { isSelected, seat, onSeatSelect, classOfService } = props;
  const currency = useSelector(selectCompanyCurrency);
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  let preferredSeat, mainCabinSeat;
  if (seat.Description) {
    preferredSeat = seat.Description.includes('Preferred');
    mainCabinSeat = seat.Description.includes('Main');
  }
  return (
    <TouchableOpacity
      style={[
        styles.seatClickContainer,
        AA_ENABLED && preferredSeat
          ? styles.seatPreferred
          : AA_ENABLED && mainCabinSeat
          ? styles.seatMainCabin
          : styles.seatDefault,
        !seat.IsAvailable ? styles.seatUnavailable : null,
        seat.isNotSelectable ? styles.seatUnselectable : null,
        isSelected && AA_ENABLED && preferredSeat
          ? styles.selectedPreferredSeat
          : isSelected && AA_ENABLED && mainCabinSeat
          ? styles.selectedMainCabinSeat
          : isSelected
          ? styles.selectedSeat
          : null,
      ]}
      onPress={() => onSeatSelect(seat, classOfService)}
    >
      {seat.IsAvailable && (
        <>
          <BaseText
            style={[
              AA_ENABLED && preferredSeat
                ? styles.seatPreferredText
                : AA_ENABLED && mainCabinSeat
                ? styles.seatMainCabinText
                : styles.seatPriceText,
              seat.isNotSelectable ? styles.notSelectableTextColor : null,
              isSelected ? styles.selectedSeatText : null,
            ]}
          >
            {getCurrencySymbolForSeatMapFare(seat.DispPrice, currency, currencyCulture)}
          </BaseText>

          <View style={styles.seatNumberContainer}>
            <BaseText
              style={[
                styles.seatNumberText,
                seat.isNotSelectable ? styles.notSelectableTextColor : null,
                isSelected ? styles.selectedSeatText : null,
              ]}
            >
              {seat.SeatNumber}
            </BaseText>
          </View>
        </>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  seatClickContainer: {
    flex: 1,
    margin: 1,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.18,
    shadowRadius: 1.0,
    elevation: 1,
    backgroundColor: 'white',
    ...CommonProperties.borderRadius,
    borderWidth: 0.6,
    width: '100%',
    ...CommonProperties.px2,
  },
  seatPreferred: {
    borderColor: Color.green,
  },
  seatMainCabin: {
    borderColor: Color.orange,
  },
  seatDefault: {
    borderColor: Color.primary,
  },
  seatPriceContainer: {
    alignItems: 'flex-start',
  },
  seatNumberContainer: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flex: 1,
  },
  seatUnselectable: {
    opacity: 1,
    borderColor: Color.disabled,
  },
  seatUnavailable: {
    backgroundColor: Color.disabled,
    borderColor: Color.disabled,
  },
  selectedPreferredSeat: {
    backgroundColor: Color.green,
    borderColor: Color.green,
  },
  selectedMainCabinSeat: {
    backgroundColor: Color.orange,
    borderColor: Color.orange,
  },
  selectedSeat: {
    backgroundColor: Color.active,
    borderColor: Color.active,
  },
  seatMainCabinText: {
    flex: 1,
    color: Color.orange,
  },
  seatPreferredText: {
    flex: 1,
    color: Color.green,
  },
  seatPriceText: {
    flex: 1,
    color: Color.primary,
  },
  seatNumberText: {
    color: Color.text.low,
    ...CommonProperties.small,
  },
  selectedSeatText: {
    color: Color.accent,
  },
  notSelectableTextColor: {
    color: Color.disabled,
  },
});

export default memo(SeatUnit, (p, n) => p.seat !== n.seat || p.isSelected !== n.isSelected);
